import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/buildhome/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArticleCard = makeShortcode("ArticleCard");
const Aside = makeShortcode("Aside");
const Video = makeShortcode("Video");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`This page is meant to demonstrate some of the components in action. You can
check out the markdown used for this page on Github.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Section heading</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Global accessibility standards</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Small anchor links</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Videos</AnchorLink>
    </AnchorLinks>
    <Row mdxType="Row">
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Getting started" href="/getting-started" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC6klEQVQoz12Ta0wNYBjH3+PWchsam5kRGzKXiqY66aRTzWUNy6KGQjPltoZii1SLdHbS3DbDXNIhDkbJZTEbJqebYnQ9RaaQ+211Lj9P8oUPz5f3fZ7/c/s9Kq0S9r2AqDOfULoqNCGVqKAHrNa+xjD7F1lBTnJ0TjJ0XbjrG1HBj+mlu49GrHdoOcqvgtCcdgx1kFruRKVXOv8ILsv7jPItQXleQE0zE+1Zzc7Jtez0tpKm+8kYfa0EF6KmFqCmXBYfMS/xnX79X8G0v4JRpz/KZxH9o2rwyPnEokw76zY5We/bwohZZSjtA5RPMW6bm/E69Z0pBz4zdG09yuMqodmt/1VYKxWavjJgTTMRd2GvFYwJsCkevHK/4bKygcGxTYzO6CDG/IuU7W/Z3wixZTB4QyshBzsw1HcLOlBZz2B3hQOvg2/xN3dxTMSK7rQR72PGdPY7a2vAPbOZUTueE/kI8u92st33ISePP+NcC8y74WBS7juSHnaSWQ1q270f6HdJSx75hF3pxGqD5Lg9jOyjpaUBsiTBoCW30WgLiC918qULAr0jiPROpOMnRN8TEf9CpsbeYo8Up1aZ3jBxeTFqkonpJ75hLIUjUR9InFjK4UPtxFjAZe4N1MzzhJfA0TudpPhZKCz5yPGXEHxJ2vS5xrCgfLqJUXEF7XiskAD3k7jFWok0OElaAhsD6oiIq2dsxgfZplk2m8fwLa9ZWmQjSRKnPEXm7WRIQqt0d5FhwSbSq0Qw9bGd6FPNDA+7SYLfF1IXO1i11Y5n8jsGxjcJd0+kuksobxMqsALXmAbGG94zNrUNl6Uv/rDbT3eTBfuqe1rOlG2lW2zsiHiFUevAGGAj18/OmEBxDihFoxfBGRcFqTyUXqCfLfP2twhGZWjmVAibFvSGN+xv6l6uYJNsbGP9/HISJ9SQPUcQ0tnIDrIzLrgOFVJO3wWNuC5swDW8jr7hVnnruaZu6xVWJcdgIUzAzq7t4fA37CE/C9xcSc4AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Dark article layout mockup",
              "title": "Dark article layout mockup",
              "src": "/static/ebd956040be4c438af81a5204152b45c/3cbba/Article_06.png",
              "srcSet": ["/static/ebd956040be4c438af81a5204152b45c/7fc1e/Article_06.png 288w", "/static/ebd956040be4c438af81a5204152b45c/a5df1/Article_06.png 576w", "/static/ebd956040be4c438af81a5204152b45c/3cbba/Article_06.png 1152w", "/static/ebd956040be4c438af81a5204152b45c/0b124/Article_06.png 1728w", "/static/ebd956040be4c438af81a5204152b45c/0c3f5/Article_06.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Theme configuration" href="/guides/configuration" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC6klEQVQoz12Ta0wNYBjH3+PWchsam5kRGzKXiqY66aRTzWUNy6KGQjPltoZii1SLdHbS3DbDXNIhDkbJZTEbJqebYnQ9RaaQ+211Lj9P8oUPz5f3fZ7/c/s9Kq0S9r2AqDOfULoqNCGVqKAHrNa+xjD7F1lBTnJ0TjJ0XbjrG1HBj+mlu49GrHdoOcqvgtCcdgx1kFruRKVXOv8ILsv7jPItQXleQE0zE+1Zzc7Jtez0tpKm+8kYfa0EF6KmFqCmXBYfMS/xnX79X8G0v4JRpz/KZxH9o2rwyPnEokw76zY5We/bwohZZSjtA5RPMW6bm/E69Z0pBz4zdG09yuMqodmt/1VYKxWavjJgTTMRd2GvFYwJsCkevHK/4bKygcGxTYzO6CDG/IuU7W/Z3wixZTB4QyshBzsw1HcLOlBZz2B3hQOvg2/xN3dxTMSK7rQR72PGdPY7a2vAPbOZUTueE/kI8u92st33ISePP+NcC8y74WBS7juSHnaSWQ1q270f6HdJSx75hF3pxGqD5Lg9jOyjpaUBsiTBoCW30WgLiC918qULAr0jiPROpOMnRN8TEf9CpsbeYo8Up1aZ3jBxeTFqkonpJ75hLIUjUR9InFjK4UPtxFjAZe4N1MzzhJfA0TudpPhZKCz5yPGXEHxJ2vS5xrCgfLqJUXEF7XiskAD3k7jFWok0OElaAhsD6oiIq2dsxgfZplk2m8fwLa9ZWmQjSRKnPEXm7WRIQqt0d5FhwSbSq0Qw9bGd6FPNDA+7SYLfF1IXO1i11Y5n8jsGxjcJd0+kuksobxMqsALXmAbGG94zNrUNl6Uv/rDbT3eTBfuqe1rOlG2lW2zsiHiFUevAGGAj18/OmEBxDihFoxfBGRcFqTyUXqCfLfP2twhGZWjmVAibFvSGN+xv6l6uYJNsbGP9/HISJ9SQPUcQ0tnIDrIzLrgOFVJO3wWNuC5swDW8jr7hVnnruaZu6xVWJcdgIUzAzq7t4fA37CE/C9xcSc4AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Dark article layout mockup",
              "title": "Dark article layout mockup",
              "src": "/static/ebd956040be4c438af81a5204152b45c/3cbba/Article_06.png",
              "srcSet": ["/static/ebd956040be4c438af81a5204152b45c/7fc1e/Article_06.png 288w", "/static/ebd956040be4c438af81a5204152b45c/a5df1/Article_06.png 576w", "/static/ebd956040be4c438af81a5204152b45c/3cbba/Article_06.png 1152w", "/static/ebd956040be4c438af81a5204152b45c/0b124/Article_06.png 1728w", "/static/ebd956040be4c438af81a5204152b45c/0c3f5/Article_06.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterMdLeft mdxType="Column">
        <ArticleCard title="Contributions" href="/contributions" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC6klEQVQoz12Ta0wNYBjH3+PWchsam5kRGzKXiqY66aRTzWUNy6KGQjPltoZii1SLdHbS3DbDXNIhDkbJZTEbJqebYnQ9RaaQ+211Lj9P8oUPz5f3fZ7/c/s9Kq0S9r2AqDOfULoqNCGVqKAHrNa+xjD7F1lBTnJ0TjJ0XbjrG1HBj+mlu49GrHdoOcqvgtCcdgx1kFruRKVXOv8ILsv7jPItQXleQE0zE+1Zzc7Jtez0tpKm+8kYfa0EF6KmFqCmXBYfMS/xnX79X8G0v4JRpz/KZxH9o2rwyPnEokw76zY5We/bwohZZSjtA5RPMW6bm/E69Z0pBz4zdG09yuMqodmt/1VYKxWavjJgTTMRd2GvFYwJsCkevHK/4bKygcGxTYzO6CDG/IuU7W/Z3wixZTB4QyshBzsw1HcLOlBZz2B3hQOvg2/xN3dxTMSK7rQR72PGdPY7a2vAPbOZUTueE/kI8u92st33ISePP+NcC8y74WBS7juSHnaSWQ1q270f6HdJSx75hF3pxGqD5Lg9jOyjpaUBsiTBoCW30WgLiC918qULAr0jiPROpOMnRN8TEf9CpsbeYo8Up1aZ3jBxeTFqkonpJ75hLIUjUR9InFjK4UPtxFjAZe4N1MzzhJfA0TudpPhZKCz5yPGXEHxJ2vS5xrCgfLqJUXEF7XiskAD3k7jFWok0OElaAhsD6oiIq2dsxgfZplk2m8fwLa9ZWmQjSRKnPEXm7WRIQqt0d5FhwSbSq0Qw9bGd6FPNDA+7SYLfF1IXO1i11Y5n8jsGxjcJd0+kuksobxMqsALXmAbGG94zNrUNl6Uv/rDbT3eTBfuqe1rOlG2lW2zsiHiFUevAGGAj18/OmEBxDihFoxfBGRcFqTyUXqCfLfP2twhGZWjmVAibFvSGN+xv6l6uYJNsbGP9/HISJ9SQPUcQ0tnIDrIzLrgOFVJO3wWNuC5swDW8jr7hVnnruaZu6xVWJcdgIUzAzq7t4fA37CE/C9xcSc4AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Dark article layout mockup",
              "title": "Dark article layout mockup",
              "src": "/static/ebd956040be4c438af81a5204152b45c/3cbba/Article_06.png",
              "srcSet": ["/static/ebd956040be4c438af81a5204152b45c/7fc1e/Article_06.png 288w", "/static/ebd956040be4c438af81a5204152b45c/a5df1/Article_06.png 576w", "/static/ebd956040be4c438af81a5204152b45c/3cbba/Article_06.png 1152w", "/static/ebd956040be4c438af81a5204152b45c/0b124/Article_06.png 1728w", "/static/ebd956040be4c438af81a5204152b45c/0c3f5/Article_06.png 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
    </Row>
    <PageDescription mdxType="PageDescription">
      <p>{`Prow scuttle parrel provost Sail ho shrouds spirits boom mizzenmast yardarm.
Pinnace holystone mizzenmast quarter crow’s nest nipperkin grog yardarm hempen
halter furl. Swab barque interloper chantey doubloon starboard grog black jack
gangway rutters.`}</p>
    </PageDescription>
    <p>{`Prow scuttle parrel provost Sail ho shrouds spirits boom mizzenmast yardarm.
Pinnace holystone mizzenmast quarter crow’s nest nipperkin grog yardarm hempen
halter furl. Swab barque interloper chantey doubloon starboard grog black jack
gangway rutters.`}</p>
    <Row mdxType="Row">
      <Column colMd={5} colLg={8} mdxType="Column">
        <h2>{`Section heading`}</h2>
        <p>{`Prow scuttle parrel provost Sail ho shrouds spirits boom mizzenmast yardarm.
Pinnace holystone mizzenmast quarter crow’s nest nipperkin grog yardarm hempen
halter furl. Swab barque interloper chantey doubloon starboard grog black jack
gangway rutters.`}</p>
        <blockquote>
          <p parentName="blockquote">{`Add-on repositories, or repos, are components built for a specific product or
experience. The repos are built on top of the core Carbon repo, and enable`}</p>
        </blockquote>
        <p>{`IBMers believe in progress—that application of intelligence, reason and science
can improve business, society and the human condition.`}</p>
      </Column>
      <Column colMd={2} colLg={3} offsetMd={1} offsetLg={1} mdxType="Column">
        <Aside mdxType="Aside">
          <p>
  <strong>
    Good design is always
    <br />
    good design.
  </strong>
          </p>
          <p>{`What we borrow from our own design history is not a mid-century aesthetic in
stylistic terms, but the modernist attitudes and approach used at the time.`}</p>
        </Aside>
      </Column>
    </Row>
    <h2>{`Small anchor links`}</h2>
    <p>{`Swab barque interloper™ chantey doubloon starboard grog black jack gangway
rutters π.`}</p>
    <AnchorLinks small mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Header</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Header again</AnchorLink>
    </AnchorLinks>
    <h3>{`Header`}</h3>
    <p>{`Prow scuttle parrel provost Sail ho shrouds spirits boom mizzenmast yardarm.
Pinnace holystone mizzenmast quarter crow’s nest nipperkin grog yardarm hempen
halter furl. Swab barque interloper chantey doubloon starboard grog black jack
gangway rutters.`}</p>
    <h3>{`Header again`}</h3>
    <p>{`Prow scuttle parrel provost Sail ho shrouds spirits boom mizzenmast yardarm.
Pinnace holystone mizzenmast quarter crow’s nest nipperkin grog yardarm hempen
halter furl. Swab barque interloper chantey doubloon starboard grog black jack
gangway rutters.`}</p>
    <ol>
      <li parentName="ol">{`This is a demonstration of an ordered list item. This list item is
particularly long to demonstrate how the text wraps and aligns with the first
line.`}
        <ol parentName="li">
          <li parentName="ol">{`This is a nested list item, it should wrap in the same way. Typically,
nested list items should be of the same type (ordered, unordered) as their
parent.`}</li>
        </ol>
      </li>
      <li parentName="ol">{`Ordered list item`}</li>
      <li parentName="ol">{`Ordered list item`}</li>
    </ol>
    <ul>
      <li parentName="ul">{`This is a demonstration of an unordered list item. This list item is
particularly long to demonstrate how the text wraps and aligns with the first
line.`}
        <ul parentName="li">
          <li parentName="ul">{`This is a nested list item, it should wrap in the same way. Typically,
nested list items should be of the same type (ordered, unordered) as their
parent.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Unordered list item`}</li>
      <li parentName="ul">{`Unordered list item`}</li>
    </ul>
    <h2>{`Images`}</h2>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "56.25%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMFAf/EABUBAQEAAAAAAAAAAAAAAAAAAAQD/9oADAMBAAIQAxAAAAHXzbizxBgqP//EABsQAAEEAwAAAAAAAAAAAAAAAAABAgMREhQz/9oACAEBAAEFAth5Pggt2Ixty9P/xAAXEQADAQAAAAAAAAAAAAAAAAAAAQIR/9oACAEDAQE/AY2kM//EABgRAQADAQAAAAAAAAAAAAAAAAEAAxIx/9oACAECAQE/Abc1okOT/8QAHhAAAgEDBQAAAAAAAAAAAAAAABEBAhAhEjFBUXH/2gAIAQEABj8C4Ib1dwZ3s1kq9P/EAB0QAAICAQUAAAAAAAAAAAAAAAABESExQVGBkaH/2gAIAQEAAT8hbFFJ1SJCYFZOSZr7pFkW7R2esf/aAAwDAQACAAMAAAAQHw//xAAXEQEBAQEAAAAAAAAAAAAAAAABABFx/9oACAEDAQE/EGoXewxS/8QAGBEBAAMBAAAAAAAAAAAAAAAAAQARMYH/2gAIAQIBAT8QARW5yOwz/8QAHRABAQABBAMAAAAAAAAAAAAAAREAIVFhcTFB8P/aAAgBAQABPxBdMkoE5NcDSTahokO2+JPUPJec8HeQwosRRVfefK3z/9k=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Large blocky illustration",
        "title": "Large blocky illustration",
        "src": "/static/8006174cef307d9cf1a013bc15b3dd6c/2e753/large-image.jpg",
        "srcSet": ["/static/8006174cef307d9cf1a013bc15b3dd6c/69549/large-image.jpg 288w", "/static/8006174cef307d9cf1a013bc15b3dd6c/473e3/large-image.jpg 576w", "/static/8006174cef307d9cf1a013bc15b3dd6c/2e753/large-image.jpg 1152w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <h2>{`Videos`}</h2>
    <Video title="Eyes" vimeoId="310583077" mdxType="Video" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      